<template>
  <!-- breadcrumb-area -->
  <section class="breadcrumb-area-two breadcrumb-bg" :style="sliderStyles">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="breadcrumb-content text-center">
<!--            <h6 class="title" style="font-size:  x-large">{{$t('Video gallery')}}</h6>-->
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="section section-team section-member my-5">
    <div class="container">
      <div class="page-actions" style="margin-bottom: 7px">
        <div class="page-action-item action-share">
          <div class="d-flex align-items-center">
            <a class="text-primary facebook" @click="shareOnFacebook">
              <i class="ph ph-facebook-logo"></i>
            </a>
            <a class="text-primary twitter" @click="shareOnTwitter">
              <i class="ph ph-twitter-logo"></i>
            </a>
            <a class="text-primary whatsapp" @click="shareOnWhatsApp">
              <i class="ph ph-whatsapp-logo"></i>
            </a>
            <a class="text-primary telegram" @click="shareOnTelegram">
              <i class="ph ph-telegram-logo"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="booking-wrap">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item2" role="presentation">
                <button class="nav-link active" id="bOOKing-tab" data-bs-toggle="tab" data-bs-target="#bOOKing-tab-pane" type="button"
                        role="tab" aria-controls="bOOKing-tab-pane" aria-selected="true"><i class="flaticon-file"></i>{{getLocaleText(element.title_kg, element.title_ru, element.title_en)}}</button>
              </li>
              <li class="nav-item2"  role="presentation">
                <button class="nav-link" id="bOOKing-tab2" data-bs-toggle="tab" data-bs-target="#bOOKing-tab-pane2" type="button"
                        role="tab" aria-controls="bOOKing-tab-pane2" aria-selected="true"><i class="fas fa-calendar-check"></i>{{getLocaleText(element.title_kg2, element.title_ru2, element.title_en2)}}</button>
              </li>
              <li class="nav-item2"  role="presentation">
                <button class="nav-link" id="trips-tab" data-bs-toggle="tab" data-bs-target="#trips-tab-pane" type="button"
                        role="tab" aria-controls="trips-tab-pane" aria-selected="false"><i class="flaticon-file"></i> {{$t('News')}}</button>
              </li>
            </ul>
            <div class="row" style="padding-top: 15px;">
              <div class="col-md-12">
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="bOOKing-tab-pane" role="tabpanel" aria-labelledby="bOOKing-tab" tabindex="0">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="tab-content-wrap important_style" v-html="getLocaleText(element.content_kg,element.content_ru,element.content_en)">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="bOOKing-tab-pane2" role="tabpanel" aria-labelledby="bOOKing-tab2" tabindex="0">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="tab-content-wrap important_style" v-html="getLocaleText(element.rate_kg,element.rate_ru,element.rate_en)">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="trips-tab-pane" role="tabpanel" aria-labelledby="trips-tab" tabindex="0">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="row fly-next-active justify-content-center">
                          <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 grid-item grid-sizer" v-for="item in newsPost" :key="item.id">
                            <div class="fly-next-item">
                              <div class="fly-next-thumb">
                                <router-link :to="{ path: '/news_detail', query: { slug: item.slug,categoryDate: 'locomotive_announcements'} }">
                                  <img alt="" class="bvi-img fixed-image-list" v-if="!item.images.length" src="@/assets/img/images/placeholder_size_2.jpg">
                                  <img class="bvi-img fixed-image-list" v-else :src="getMainImage(item.images)" alt="">
                                </router-link>
                              </div>
                              <div class="fly-next-content">
                                <span>{{ formatDate(item.created) }}</span>
                                <div style="height: 100px">
                                  <h4 class="title fly-next-content-title">{{ getLocaleText(item.title_kg, item.title_ru, item.title_en) }}</h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <nav aria-label="Page navigation">
                          <ul class="pagination justify-content-center mt-4">
                            <li class="page-item">
                              <a class="page-link"
                                 href="#"
                                 @click="changePageNews(newsCurrentPage - 1)">
                                {{ $t('Previous') }}
                              </a>
                            </li>
                            <li class="page-item" v-for="pageNumber in pageNumberNews" :key="pageNumber" :class="{active:newsCurrentPage == pageNumber || pageNumber === '....'}">
                              <a class="page-link"
                                 href="#" @click="changePageNews(pageNumber)">{{pageNumber}}</a>
                            </li>
                            <li class="page-item">
                              <a class="page-link"
                                 href="#"
                                 @click="changePageNews(newsCurrentPage +1)">
                                {{ $t('NextNext') }}
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import getLocaleText from "@/locales/getLocaleText";
import i18n from "@/local18";
import {useBVI} from "@/useBVI";
import {computed} from "vue";
export default {
  name: 'liderView',
  setup(){
    const  bviImage  = useBVI();
    const sliderStyles = computed(() => {
      if (bviImage.imageMode.value === 'off') {
        return { background: '#fff'};
      } else if (bviImage.imageMode.value === 'grayscale') {
        return { filter: 'grayscale(100%)' };
      }
      return {};
    });
    return{
      sliderStyles
    }
  },
  data() {
    return {
      currentUrl:window.location.href,
      element: {},
      News:[],
      itemPerPage:8,
      newsCurrentPage:1,
    };
  },
  computed:{
    newsPost(){
      const startPage= (this.newsCurrentPage - 1) * this.itemPerPage;
      const endPage= startPage+this.itemPerPage;
      return this.News.slice(startPage, endPage);
    },
    totalNews(){
      return Math.ceil(this.News.length/this.itemPerPage)
    },
    pageNumberNews(){
      let pageNumbers = []
      if (this.totalNews<=7){
        for(let i = 1;i<=this.totalNews;i++){
          pageNumbers.push(i);
        }
      }
      else {
        if(this.newsCurrentPage<=4){
          pageNumbers = [1,2,3,4,5,"....",this.totalNews];
        }
        else if (this.newsCurrentPage<=this.totalNews-3){
          pageNumbers = [1,"....",this.newsCurrentPage-2,this.newsCurrentPage-1,this.newsCurrentPage,this.newsCurrentPage+1,this.newsCurrentPage+2,"....",this.totalNews];

        }
        else {
          pageNumbers = [1,"....",this.totalNews-4,this.totalNews-3,this.totalNews-2,this.totalNews-1,this.totalNews]
        }
      }
      return pageNumbers;
    },
  },
  watch: {
    '$i18n.locale': function(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        this.fetchData();
        this.fetchNews();
      }
    }
  },
  created() {
    this.fetchData();
    this.fetchNews();
  },
  methods: {
    shareOnTwitter (){
      window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(this.currentUrl)}`, '_blank', 'width=400,height=300');
    },
    shareOnFacebook(){
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentUrl)}`, '_blank', 'width=400,height=300');
    },
    shareOnWhatsApp(){
      window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(this.currentUrl)}`, '_blank');
    },
    shareOnTelegram(){
      window.open(`tg://msg_url?url=${encodeURIComponent(this.currentUrl)}`, '_blank');
    },
    changePageNews(page){
      if(page >=1 && page <= this.totalNews){
        this.newsCurrentPage = page;
      }
    },
    async fetchData() {
      try {
        const response = await axios.get('lokomotiv');
        this.element = response.data[0];
      } catch (error) {
        console.error('API data fetch error:', error);
      }
    },
    async fetchNews() {
      try {
        const local = i18n.global.locale.value;
        const response = await axios.get(`news?lang=${local}&category=locomotive_announcements`);
        this.News = response.data.results;
      } catch (error) {
        console.error('API data fetch error:', error);
      }
    },
    getLocaleText,
    getMainImage(images){
      let mainImage=images.find(item =>item.main_image);
      if(mainImage){
        return mainImage.image_size_2
      }
      else{
        return images[0].image_size_2
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    }
  },
}
</script>


<style>
.card {
  gap: 0;
  padding: 0;
  border: 0;
}

.card-body{
  padding: 24px;
}

.card-title{
  margin-bottom: 24px;
}


.btn {
  border-radius: 0;
  background: #4d5aa3;
  color: #fff;
  padding-left: 30px;
  padding-right: 30px;
  margin-right: 7px;
}

.btn:hover{
  border-radius: 0;
  background: #222c62;
}

.section-tools-wrapper>div {
  /* margin-right: 20px; */
}

.section-member .section-body article,
.section-member .section-body article p,
.section-member .section-body article span{
  font-family: "Inter", sans-serif !important;
  font-size: 16px;
}
</style>